import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getHCTicketStatus, respHCTicketStatus } from "../../utils/GetAdmin";
import { sendAllPDFs, sendPDF, respSendPDF } from "../../utils/PostAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import {formatDate} from "../../utils/Formatter";
import { GetStatusBadge } from "../../components/request/requestUtils";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150,
    },
  })
);
export default function ISupHCTicketStatus() {
  const classes = useStyles();
  const [hcTicketStatus, setHcTicketStatus] = useState<respHCTicketStatus|undefined>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [codes, setCodes] = React.useState<any>();
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  
  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES","vp_req_status"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        getHCTicketStatus(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v){
            setHcTicketStatus(v);
          }
        });
      });
      
  }, [hcTicketStatus, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && hcTicketStatus && enabled? (
        <div>
              <TableAbstraction
                settingsKey="ADM_IS_HC_TC"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  tableBodyHeight: TABLE_BODY_HEIGHT,
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    muiTable.rpp = numberOfRows;
                    setMuiTable(muiTable);
                  },
                }}
                title={hcTicketStatus.message}
                columns={[
                  {
                    label: "VPR#",
                    name: "requestNum",
                    options: {
                      searchable: false,
                      filter: true,
                    },
                  },
                  {
                    label: "Customer",
                    name: "customerNum",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "SAP Ticket#",
                    name: "sapRequestNum",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "VPR Status",
                    name: "requestStatus",
                    options: {
                      searchable: false,
                      filter: false,
                      customBodyRender: (value: any) =>  (<GetStatusBadge status={value} codes={codes} />),
                    },
                  },
                  {
                    label: "SAP Ticket Status",
                    name: "ticketStatus",
                    options: {
                      searchable: false,
                      filter: false,
                      customBodyRender: (value: any) =>  (<GetStatusBadge status={value} codes={codes} />),
                    },
                  },
                  {
                    label: "Optimization Type",
                    name: "optimizationType",
                    options: {
                      searchable: false,
                      filter: false,
                    },
                  },
                  {
                    label: "Execution Date",
                    name: "executionDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return value?formatDate(value,''):''}
                    },
                  },
                  {
                    label: "Last Change",
                    name: "lastChangeDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return value?formatDate(value,''):''}
                    },
                  },
                  {
                    label: "Close Date",
                    name: "closeDateDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return value?formatDate(value,''):''}
                    },
                  },
                  {
                    label: "Email Date",
                    name: "pdfEmailDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return value?formatDate(value,''):''}
                    },
                  },
                  {
                    label: "Visit Date",
                    name: "visitDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return value?formatDate(value,''):''}
                    },
                  },
                  {
                    label: "Requested Visit Date",
                    name: "requestedDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return value?formatDate(value,''):''}
                    },
                  },
                  {
                    label: "SAP Ticket Mode",
                    name: "ticketMode",
                    options: {
                      searchable: false,
                      filter: false,
                    },
                  },
                ]}
                data={hcTicketStatus.ticketStatus}
              />
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}